<script>
  export default {
    data() {
      return {
        options: {},

        code: {},

        itemsName: '',
        items: []
      }
    },

    props: ['hideCallback'],

    mounted() {
      this.options = this.co2Service.getOptions();
    },

    methods: {
      show(itemsName, code) {

        console.log('itemsName', itemsName);
        console.log('code', code);

        this.itemsName = itemsName;
        this.items = this.co2Service[itemsName];
        this.code = this.decodeCode(code);
        this.$refs.estModal.show();
      },
      submitCode() {
        this.hideCallback(this.itemsName, this.encodeCode(this.code));
        this.$refs.estModal.hide()
      },
      decodeCode(codeString) { // String in Array
        if(!codeString || codeString.length !== 14) {
          return ['b','c','a','c','c','a','b','b','b','b','b','a','b','b']
        }
        if(codeString.length === 14) {
          return codeString.split('');
        }
      },
      encodeCode(codeArray) { // Array in String
        return codeArray.join('');
      },
    }

  }

</script>
<style scoped lang="scss"></style>
<template>
  <div class="est-modal">

    <b-modal size="lg" ref="estModal" hide-footer lazy
             no-close-on-backdrop hide-header-close
             no-close-on-esc title="Jahresverbrauch schätzen">

      <b-row>
        <b-col md="6" v-for="item in items" :key="item.index">

          <b-form-group :id="'group-' + item.tag"
                        :label-for="'radio-' + item.tag">
            <template slot="label">
              <span class="text-primary">{{item.name}}:</span>
            </template>
            <b-form-radio-group
              :id="'radio-' + item.tag"
              v-model="code[item.index]"
              :options="options[item.option]"
              :name="'radio-' + item.tag"
              stacked
            ></b-form-radio-group>
          </b-form-group>

        </b-col>
      </b-row>

      <hr>
      <div class="float-right">
        <b-button class="mr-2" size="sm" rounded variant="warning" @click="$refs.estModal.hide()">
          <font-awesome-icon class="fa-fw mr-1" icon="times"></font-awesome-icon>
          <span>Bearbeitung abbrechen</span>
        </b-button>
        <b-button size="sm" rounded variant="success" @click="submitCode()">
          <font-awesome-icon class="fa-fw mr-1" icon="save"></font-awesome-icon>
          <span>Angaben übernehmen</span>
        </b-button>
      </div>

    </b-modal>

  </div>
</template>
